import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useOutletContext } from "react-router-dom";
import ImageInput from "../../../components/WriteProject/ImageInput/ImageInput";
import WpInput from "../../../components/WriteProject/WpInput/WpInput";
import WpTitle from "../../../components/WriteProject/WpTitle/WpTitle";
import { MeetupType } from "../../../interface/interface";
import { PopupChange } from "../../../reducers/config";

function MagazineStep1() {
  const patch = useDispatch();
  const {
    state: { category, mainimg, leader, title, link },
    isError,
    UpdateCommon,
  }: {
    state: MeetupType;
    dispatch: (p: object) => void;
    isError: boolean;
    UpdateCommon: (type: string, payload: string | number | boolean) => void;
  } = useOutletContext();

  const __searchLeader = useCallback(() => {
    patch(
      PopupChange({
        active: true,
        type: "leader",
        content: "writeMeetup",
      })
    );
  }, [patch]);

  return (
    <div className="step1">
      <WpTitle title="기본 정보" />
      <div className="basic-info">
        <div className="left">
          <WpInput
            title="매거진명"
            placeholder="프로젝트 명을 입력해주세요"
            initial={title}
            max={29}
            type="text"
            reg={"title"}
            __update={UpdateCommon}
            error={
              isError && title.length < 1
                ? "매거진명을 입력해주세요"
                : undefined
            }
          />
          <div className="category-wrapper">
            <div className="title">
              카테고리 <span>택1</span>
            </div>
            <div className="btn-wrapper">
              {categoryArr.map(({ text, type }, idx) => {
                return (
                  <button
                    key={idx}
                    className={category === type ? "active-category" : ""}
                    onClick={() => {
                      UpdateCommon("category", type);
                    }}
                  >
                    {text}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="leader-wrapper">
            {category === "MGN_01" ? (
              <div className={`select-wrapper`}>
                <div className="title">
                  팀 리더명
                  <div
                    className={`error-msg ${
                      isError && leader.id.length < 1 ? "active-error" : ""
                    }`}
                  >
                    {isError && leader.id.length < 1
                      ? "팀 리더를 선택해주세요"
                      : undefined}
                  </div>
                </div>
                <div
                  className={`leader-select ${
                    leader.id ? "choice-leader" : ""
                  } ${isError && leader.id.length < 1 ? "select-error" : ""}`}
                  onClick={__searchLeader}
                >
                  <div className="title">
                    {leader.id
                      ? leader.name
                        ? leader.name
                        : "선택 완료"
                      : "팀 리더 선택"}
                  </div>
                  <img src="/assets/project/right-arrow.svg" alt="" />
                </div>
              </div>
            ) : undefined}
            <WpInput
              title={category === "MGN_01" ? "팀 리더 추가설명" : "부제"}
              placeholder={
                category === "MGN_01"
                  ? "예 ) 현 삼성카드 데이터 분석팀 팀장"
                  : "부제를 입력해주세요"
              }
              initial={leader.sub}
              max={25}
              type="text"
              reg={"leader/sub"}
              __update={UpdateCommon}
              error={
                isError && leader.sub.length < 1
                  ? "설명을 입력해주세요"
                  : undefined
              }
            />
          </div>
          <div className="meetup-place-wrapper">
            <WpInput
              title="하단 링크"
              placeholder="하단 링크 입력"
              initial={link}
              max={undefined}
              type="text"
              reg={"link"}
              __update={UpdateCommon}
              error={undefined}
            />
          </div>
        </div>
        <div className="right">
          <ImageInput
            title="썸네일 이미지"
            sub="jpg / png 확장자 / 564x475px 권장"
            data={mainimg}
            __update={UpdateCommon}
            isError={isError}
            type="mainimg"
          />
        </div>
      </div>
    </div>
  );
}

export default MagazineStep1;

const categoryArr = [
  { text: "월간 팀리더", type: "MGN_01" },
  { text: "팀플러 인터뷰", type: "MGN_02" },
  { text: "워크스토리", type: "MGN" },
];
